<!-- ************************************************************************************************* -->
<waitLoading *ngIf="!isLoaded()"></waitLoading>
<!-- ************************************************************************************************* -->
<div class=" wrapper wrapper-content ng-scope animated fadeInRight" *ngIf="isLoaded()">
  <div class="container-fluid  m-b-lg">
    <div class="row m-t-md">
      <!-- zona de filtros -->
      <div class="col-12">
        <p-panel>
          <p-header>
            <span>
              <i class="fa fa-filter" aria-hidden="true"></i> {{'General.filters' | translate}}</span>
          </p-header>
          <div class="row">
            <div class="col-6 m-b-md">
              <label for="from">{{'General.date.ini' | translate}}:</label>
              <p-calendar id="from" [(ngModel)]="filters.from" showIcon="true" [showTime]="true" autofocus
                [dateFormat]="PRIMENG_DATE_FORMAT" [firstDayOfWeek]=1></p-calendar>
            </div>
            <div class="col-6 m-b-md">
              <label for="to">{{'General.date.end' | translate}}:</label>
              <p-calendar id="to" [(ngModel)]="filters.to" showIcon="true" [showTime]="true"
                [dateFormat]="PRIMENG_DATE_FORMAT" [firstDayOfWeek]=1>
              </p-calendar>
            </div>
            <div class="col-6 m-b-md">
              <label for="timeUnits">Unidad de tiempo:</label>
              <p-dropdown id="timeUnits" [options]="timeUnits" [ngModel]="filters.timeUnit"
                (onChange)="changeTimeUnit($event)"></p-dropdown>
            </div>
            <div class="col-12">
              <button class="btn btn-primary" (click)="search()" type="button">{{'General.search.text' |
                translate}}</button>
            </div>
          </div>
        </p-panel>
      </div>
    </div>
    <div class="row m-t-md">
      <div class="col-12">
        <!-- tiempo globales en formato widget-->
        <p-panel>
          <p-header>
            <span>
              <i class="fa fa-info" aria-hidden="true"></i> Monitorización del sistema <span *ngIf="filters.from">desde
                el día {{filters.from | date}}</span>
              <span *ngIf="filters.to">hasta el día {{filters.to | date}}</span>
            </span>
          </p-header>
          <div class="row">
            <div class="col-12 col-md-4">
              <div class="widget style1 bg-azul1">
                <div class="row">
                  <div class="col-4 col-4">
                    <i class="fa fa-list-ol fa-5x"></i>
                  </div>
                  <div class="col-8 col-8 text-right">
                    <span>Peticiones</span>
                    <h2 class="font-bold">{{globalData.count | number}}</h2>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="widget style1 bg-warning">
                <div class="row">
                  <div class="col-4">
                    <i class="fa fa-clock-o fa-5x"></i>
                  </div>
                  <div class="col-8 text-right">
                    <span>Tiempo medio</span>
                    <h2 class="font-bold">{{globalData.averageTime | number}} ms</h2>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="widget style1 bg-info">
                <div class="row">
                  <div class="col-4">
                    <i class="fa fa-exclamation-circle fa-5x"></i>
                  </div>
                  <div class="col-8 text-right">
                    <span>Tiempo máximo</span>
                    <h2 class="font-bold">{{globalData.maxTime | number}} ms</h2>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <p-chart type="line" [data]="globalCountData"></p-chart>
            </div>
            <div class="col-12 col-md-6">
              <p-chart type="line" [data]="globalAvgData"></p-chart>
            </div>
          </div>
        </p-panel>
      </div>
    </div>
    <div class="row m-t-md">
      <div class="col-12">
        <!-- tiempo globales por servicio-->
        <p-panel>
          <p-header>
            <span>
              <i class="fa fa-file" aria-hidden="true"></i> Información global desglosada por servicio</span>
            <span class="leyenda float-right">{{ 'Audit.total' | translate }} {{globalAudits ? globalAudits.length :
              '0'}}</span>
          </p-header>
          <p-table [value]="globalAudits" sortField="averageTime" sortOrder="0" [paginator]="true" [rows]="10"
            [paginator]="true" [pageLinks]="4" [rows]="10" class="footer-over-pagination">
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="6"> {{ 'General.noFilteredData' | translate }} </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="identifier" styleClass="col-6">identifier <p-sortIcon field="identifier">
                  </p-sortIcon>
                </th>
                <th pSortableColumn="count" styleClass="col-1 text-right">count <p-sortIcon field="count"></p-sortIcon>
                </th>
                <th pSortableColumn="averageTime" styleClass="col-1 text-right">averageTime <p-sortIcon
                    field="averageTime"></p-sortIcon>
                </th>
                <th pSortableColumn="minTime" styleClass="col-1 text-right">minTime <p-sortIcon field="minTime">
                  </p-sortIcon>
                </th>
                <th pSortableColumn="maxTime" styleClass="col-1 text-right">maxTime <p-sortIcon field="maxTime">
                  </p-sortIcon>
                </th>
                <th styleClass="text-right action-column">
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-resource>
              <tr>
                <td field="identifier">{{resource.identifier}}</td>
                <td field="count">{{resource.count}}</td>
                <td field="averageTime">{{resource.averageTime}}</td>
                <td field="minTime">{{resource.minTime}}</td>
                <td field="maxTime">{{resource.maxTime}}</td>
                <td>
                  <button type="button" class="btn btn-xs btn-default" aria-expanded="false"
                    (click)="analyze(resource)">
                    <i class="fa fa-area-chart" aria-hidden="true"></i>
                  </button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-panel>
      </div>
    </div>
    <div class="row m-t-md">
      <div class="col-12" *ngIf="audits && audits.length > 0">
        <!-- información desglosada-->
        <p-panel>
          <p-header>
            <span>
              <i class="fa fa-file" aria-hidden="true"></i> Datos del servicio {{currentService.identifier}}}</span>
            <span class="leyenda float-right">{{ 'Audit.total' | translate }} {{audits ? audits.length : '0'}}</span>
          </p-header>
          <div class="row">
            <div class="col-12 col-md-6">
              <p-chart type="line" [data]="countData"></p-chart>
            </div>
            <div class="col-12 col-md-6">
              <p-chart type="line" [data]="avgData"></p-chart>
            </div>
            <div class="col-12">
              <p-table [value]="audits" sortField="period" sortOrder="1" [paginator]="false"
                class="footer-over-pagination">
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="5"> {{ 'General.noFilteredData' | translate }} </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="header">
                  <tr>
                    <th pSortableColumn="period" styleClass="col-3">period <p-sortIcon field="period">
                      </p-sortIcon>
                    </th>
                    <th pSortableColumn="count" styleClass="col-2 text-right">count <p-sortIcon field="count">
                      </p-sortIcon>
                    </th>
                    <th pSortableColumn="averageTime" styleClass="col-2 text-right">averageTime <p-sortIcon
                        field="averageTime"></p-sortIcon>
                    </th>
                    <th pSortableColumn="minTime" styleClass="col-2 text-right">minTime <p-sortIcon field="minTime">
                      </p-sortIcon>
                    </th>
                    <th pSortableColumn="maxTime" styleClass="col-2 text-right">maxTime <p-sortIcon field="maxTime">
                      </p-sortIcon>
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-resource>
                  <tr>
                    <td field="period">{{resource.period}}</td>
                    <td field="count">{{resource.count}}</td>
                    <td field="averageTime">{{resource.averageTime}}</td>
                    <td field="minTime">{{resource.minTime}}</td>
                    <td field="maxTime">{{resource.maxTime}}</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </p-panel>
      </div>
    </div>
  </div>
</div>